/** Shared Forge content contract. Each product uses its own origin and login. */
export type FileView = 'my' | 'team' | 'shared'
export interface ContentFile {
  file_id: string; name: string; version: number; updated_at: string
  size_bytes: number; content_hash: string; access: 'owner' | 'edit' | 'read'
  can_write: boolean; can_share: boolean; library_id: string | null; library_name: string | null
  metadata_version: number; folder_id: string | null; can_manage: boolean; can_return_private: boolean
  deleted_at: string | null
  mime_type?: string; can_edit?: boolean; previewable?: boolean
}
export interface ContentTeam { team_id: string; name: string; organization_name: string }
export interface ContentLibrary { library_id: string; name: string; team_id: string; file_count?: number }
export interface ContentShare { recipient_id: string; recipient_label: string; permission: 'read' | 'edit' }
export interface LibraryListing { libraries: ContentLibrary[]; teams: ContentTeam[]; can_write: boolean }
export interface FileListing { files: ContentFile[]; can_write: boolean; offset: number; limit: number }

export async function contentRequest<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers)
  headers.set('X-Office-Request', '1')
  if(!headers.has('X-Workspace-Context')&&typeof document!=='undefined'&&document.documentElement.dataset.workspaceContext)headers.set('X-Workspace-Context',document.documentElement.dataset.workspaceContext)
  if (options.body && !(options.body instanceof FormData)) headers.set('Content-Type', 'application/json')
  const perform=()=>fetch('/api' + path, { ...options, headers, credentials: 'same-origin', cache: 'no-store' })
  let response:Response
  try{response=await perform()}catch(error){
    // Only creation requests with a durable server receipt may be replayed.
    if(options.method!=='POST'||!headers.has('Idempotency-Key')||options.signal?.aborted)throw error
    response=await perform()
  }
  if (!response.ok) {
    const body = await response.json().catch(() => ({}))
    throw Object.assign(new Error(body.detail || `File request failed (${response.status})`), { status: response.status, code: response.headers.get('X-Error-Code') || undefined, outcome: response.headers.get('X-Input-Outcome') || undefined })
  }
  return response.json() as Promise<T>
}
export const office = <T>(path: string, options?: RequestInit) => contentRequest<T>('/office' + path, options)
export const libraries = <T>(path = '', options?: RequestInit) => contentRequest<T>('/forge/libraries' + path, options)

/** Immutable references to external evidence open outside the native editor. */
export function sourceLink(source: {file_id:string; version?:number; section_id?:string; origin?:string; memory_id?:string}) {
  if(source.origin==='human'&&source.memory_id)return '/api/knowledge/office/memory/'+encodeURIComponent(source.memory_id)+'?revision='+source.version
  const query = new URLSearchParams({[source.file_id.startsWith('cloud_')?'source':'file']:source.file_id})
  if(source.version) query.set('source_version',String(source.version))
  if(source.section_id) query.set('source_section',source.section_id)
  return (source.file_id.startsWith('cloud_')?'/connections':'/')+'?'+query
}
